import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronUp } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { pathname } = useLocation();

  const toggleVisibility = () => {
    // Check window scroll position first (for most common cases)
    if (window.pageYOffset > 300) {
      setIsVisible(true);
      return;
    }

    // Then check main container as fallback
    const mainContainer = document.querySelector('main');
    if (mainContainer && mainContainer.scrollTop > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    // Try scrolling the main container
    const mainContainer = document.querySelector('main');
    if (mainContainer) {
      mainContainer.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
    
    // Also scroll window to top as fallback
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    // Listen to both window and main container scroll events
    window.addEventListener('scroll', toggleVisibility);
    
    const mainContainer = document.querySelector('main');
    if (mainContainer) {
      mainContainer.addEventListener('scroll', toggleVisibility);
    }
    
    // Initial check
    toggleVisibility();
    
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
      if (mainContainer) {
        mainContainer.removeEventListener('scroll', toggleVisibility);
      }
    };
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use 'smooth' for smooth scrolling
    });
  }, [pathname]);

  return (
    <div className="fixed bottom-6 right-6 z-[100]">
      <AnimatePresence>
        {isVisible && (
          <motion.button
            onClick={scrollToTop}
            className="group relative bg-gradient-to-r from-blue-600 to-purple-600 text-white p-3.5 rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.5 }}
            whileHover={{ y: -4 }}
            whileTap={{ scale: 0.9 }}
            aria-label="Scroll to top"
          >
            <FaChevronUp size={18} />
            
            {/* Tooltip */}
            <span className="absolute -top-10 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs py-1.5 px-3 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
              Back to top
            </span>
            
            {/* Ripple Effect */}
            <span className="absolute inset-0 rounded-full bg-white opacity-30 animate-ping pointer-events-none"></span>
            
            {/* Glow Effect */}
            <span className="absolute -inset-1 bg-gradient-to-r from-blue-400 to-purple-400 opacity-30 blur rounded-full -z-10 pointer-events-none"></span>
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
};

export default ScrollToTop;
